import { FC } from "react";
import {
  BomPageExplainerSectionDescription,
  BomPageExplainerSectionTitle,
} from "../atoms";

interface BomPageExplainerSectionProps {
  title: string;
  description: string;
  image: string;
}

export const BomPageExplainerSection: FC<BomPageExplainerSectionProps> = ({
  title,
  description,
  image,
}) => {
  return (
    <>
      <div className="grid gap-[0.3125rem]">
        <BomPageExplainerSectionTitle title={title} />
        <BomPageExplainerSectionDescription description={description} />
      </div>
      <img src={image} alt={title} />
    </>
  );
};
